@if (!hideAll) {
<app-dialog-mode-switcher
  *onlyForScreens="['desktop', 'tablet']"
  location="share-gallery-dialog"
  [modes]="menuItems"
  [(mode)]="mode"
></app-dialog-mode-switcher>
<div class="main-container">
  @if (mode === 'link') {
  <app-share-sub-gallery-link [gallery]="gallery"></app-share-sub-gallery-link>
  } @if (mode === 'embed') {
  <app-share-gallery-embed [gallery]="gallery" (onChangeMode)="mode = $event"> </app-share-gallery-embed>
  }
</div>
<app-sticky-footer [items]="menuItems" (onItemClick)="mode = $event.key" [selected]="mode" *onlyForScreens="['mobile']">
</app-sticky-footer>
}
